import type {
  ElectricityHeatSteamConsumptionData,
  ElectricityHeatSteamConsumptionDataCertificateAttachment,
} from './electHeatSteamTypes';

import { createSelectorCreator, lruMemoize } from 'reselect';
import { isEqual } from 'es-toolkit';
import type { RootState } from '/business/shared/state/store';
import type { BasketItem } from '/business/shared/state/reducers/basket';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

const heatSteamElectGroupApiKeys = [
  'calc-elect-consumption-flag-steam',
  'calc-elect-consumption-flag-heat',
  'calc-elect-consumption-flag-elect',
] as const;
type ElectricityHeatSteamType = (typeof heatSteamElectGroupApiKeys)[number];
const EMPTY_ARRAY: never[] = [];

type ElectricityHeatSteamBasketItem = BasketItem & {
  type: ElectricityHeatSteamType;
  itemId: number;
  tonnage?: number | null;
  certificates?: ElectricityHeatSteamConsumptionDataCertificateAttachment[] | null;
  genericData: ElectricityHeatSteamConsumptionData;
};

const isElectricityHeatSteamBasketItem = (item: BasketItem): item is ElectricityHeatSteamBasketItem => {
  return heatSteamElectGroupApiKeys.some((apiKey) => apiKey === item.type);
};

export default createDeepEqualSelector(
  (state: RootState) => state.basket?.items || EMPTY_ARRAY,
  (rawItems) => {
    const filtered = rawItems.filter(isElectricityHeatSteamBasketItem);
    if (filtered.length === 0) {
      return [];
    }
    return filtered.map((item) => {
      return {
        ...item.genericData,
        id: item.itemId,
        type: item.type,
        certificates: item.certificates || [],
        tonnage: item.tonnage || 0,
      };
    });
  },
);
